webpackJsonp([238,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ResultApp = __webpack_require__(825);
	
	var _ResultApp2 = _interopRequireDefault(_ResultApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	    el: '#result1-app',
	    template: '<ResultApp1/>',
	    components: { ResultApp1: _ResultApp2.default }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(2);
	
	exports.default = {
	    name: 'result1',
	    components: {},
	    created: function created() {},
	    data: function data() {
	        return {};
	    },
	    mounted: function mounted() {},
	
	    methods: {}
	};

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(499)
	
	/* script */
	__vue_exports__ = __webpack_require__(267)
	
	/* template */
	var __vue_template__ = __webpack_require__(1016)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-48cda340"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main_content",
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_c('div', {
	    staticClass: "c-title",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("隐私政策")]), _vm._v(" "), _c('p', [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("1、尊重与保护用户个人信息是本服务的一项基本原则。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("2、本业务需采集用户的个人信息包括：手机号码、IP地址。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("3、用户同意本服务基于以下事项使用用户的个人信息：")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("（1）读取、上传、记录用户个人信息数据并进行同步、分享和储存以实现部分服务功能；")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("（2）收集用户个人信息数据并统计、分析及研究，以改进本服务的质量；")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("（3）改进或提高用户的使用安全性和服务性；")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("（4）向用户发送本服务的重要通知和服务信息；")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("（5）适用法律法规规定的其他事项。 （可根据应用实际情况修改补充）除上述事项外，如未取得用户事先同意，本应用不会将用户个人信息使用于任何其他用途。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("4、本服务采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、毁损或丢失。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-indent": "2em"
	    }
	  }, [_vm._v("5、本服务承诺未经用户同意不向任何第三方公开、透露用户个人信息，但法律法规规定或有权机关的指示提供用户的个人信息除外。")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/privacy/content.cd0f653e7f5532304b63.js